export const CacheInvalidationPeriod = 15;

export const DeviceGroupMaxLength = 25;
export const PostalCodeMaxLength = 25;
export const TickerMaxLength = 140;

export const DefaultMaxLength = 191;
